
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { execCommandClip } from '@/utils/clipboard';
import { showToast } from '@/fit-components/toast/main';
import { ToastType } from '@/fit-components/toast/business';
import { i18n } from '@/i18n';

@Component({
  components: {
  },
})
export default class BusinessCard extends Vue {
  @Prop() private link!: string;  // 链接
  copy() {
    const isSuc = execCommandClip(this.link);
    this.$emit('clickCopyBtn');
    if (isSuc) {
      showToast({
        show: false,
        type: ToastType.Tick,
        title: i18n('复制成功'),
      });
      this.$emit('copySuccess');
    } else {
      this.$emit('copyFail');
    }
  }
}
